/* istanbul ignore file */
import { createScopedInstanceAndLoader, getLanguage } from '@citrite/translate';
const instance: any = createScopedInstanceAndLoader({
	namespace: 'storage-plugin-pilet',
	localesLoaderMap: {
		en: () => import('./locales/en.json'),
		es: () => import('./locales/es.json'),
		ja: () => import('./locales/ja.json'),
		de: () => import('./locales/de.json'),
		fr: () => import('./locales/fr.json'),
		'pt-BR': () => import('./locales/pt-BR.json'),
		it: () => import('./locales/it.json'),
		nl: () => import('./locales/nl.json'),
	},
	compatibilityJSON: 'v4',
});

export type TFunction = typeof instance.t;
type TKey = Parameters<TFunction>[0];
export type StorageTFunction = (key: TKey, options?: any) => string;

export const { LocalizationLoader }: any = instance;
const { t } = instance;
// defaultT method should be used only for genric errors where custom labels are not required.
// Other wise use t method available in the context.
export { t as defaultT };

export { getLanguage };
